import { render, staticRenderFns } from "./licenseHome.vue?vue&type=template&id=fab3d5b8&scoped=true"
import script from "./licenseHome.vue?vue&type=script&lang=js"
export * from "./licenseHome.vue?vue&type=script&lang=js"
import style0 from "./licenseHome.vue?vue&type=style&index=0&id=fab3d5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab3d5b8",
  null
  
)

export default component.exports